export default function () {
 jQuery('.readLessBlock').hide()

    jQuery(window).ready(function(){
        jQuery('a.readMore').on('click',function(event){
            event.preventDefault();
            jQuery(this).parent().hide().next().show()
            // jQuery('.readMoreBlock').hide()
        })

        jQuery('a.readLess').on('click',function(event){
            event.preventDefault();
            jQuery(this).parent().hide().prev().show()
        })
    })
}



// WEBPACK FOOTER //
// ./scripts/testimonials.js